import {
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch
} from "@mui/material";
import { FastField, FieldArray } from "formik";
import {
  MyButton,
  MyMultiSelect,
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea
} from "../Lib/componentLibrarys";
import { AddCircleOutline, Check, Close } from "@mui/icons-material";
import { useState } from "react";

export const FormNhap = ({
  values,
  errors,
  setFieldValue,
  sanPhamList,
  vungSanXuatList,
  coSoCheBienList,
  coSoPhanPhoiList,
  coSoSanXuatList
}) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <FastField name="tenLoHang">
            {({ field }) => (
              <MyTextField
                required
                label="Tên lô hàng:"
                placeholder="Nhập..."
                errors={errors?.tenLoHang}
                helperText={errors?.tenLoHang}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            label="Sản phẩm:"
            placeholder="Chọn..."
            value={values?.sanPham}
            options={sanPhamList || []}
            name="tenSanPham"
            onChange={(event, value) => {
              setFieldValue(`sanPham`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Vùng sản xuất:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`vungSanXuats`, value);
            }}
            value={values?.vungSanXuats || []}
            options={vungSanXuatList || []}
            name="tenVungSanXuat"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Cơ sở sản xuất:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`coSoSanXuats`, value);
            }}
            value={values?.coSoSanXuats || []}
            options={coSoSanXuatList || []}
            name="tenCoSoSanXuat"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Cơ sở chế biến:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`coSoCheBiens`, value);
            }}
            value={values?.coSoCheBiens || []}
            options={coSoCheBienList || []}
            name="tenCoSoCheBien"
          />
        </Grid>
        <Grid item xs={6}>
          <MyMultiSelect
            label="Cơ sở phân phối:"
            placeholder="Chọn..."
            onChange={(option, value) => {
              setFieldValue(`coSoPhanPhois`, value);
            }}
            value={values?.coSoPhanPhois || []}
            options={coSoPhanPhoiList || []}
            name="tenCoSoPhanPhoi"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            label="Ngày xuất bán:"
            placeholder="Chọn..."
            value={values?.ngayXuatBan}
            onChange={value => {
              setFieldValue(`ngayXuatBan`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="hanSuDung">
            {({ field }) => (
              <MyTextField
                label="Hạn sử dụng:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="sanLuong">
            {({ field }) => (
              <MyTextField
                label="Sản lượng:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                checked={values?.trangThai}
                onChange={(event, value) => {
                  setFieldValue("trangThai", value);
                }}
              />
            }
            label="Trạng thái"
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};

export const FormThongTinLichSu = ({
  values,
  errors,
  setFieldValue,
  loHangList
}) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={6}>
          <MySelect
            required
            label="Lô hàng:"
            placeholder="Chọn..."
            value={values?.loHang}
            options={loHangList || []}
            name="tenLoHang"
            onChange={(event, value) => {
              setFieldValue(`loHang`, value);
            }}
            errors={errors?.tenLoHang}
            helperText={errors?.tenLoHang}
          />
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            label="Ngày gieo trồng:"
            placeholder="Chọn..."
            value={values?.ngayGieoTrong}
            onChange={value => {
              setFieldValue(`ngayGieoTrong`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelectTime
            label="Ngày thu hoạch:"
            placeholder="Chọn..."
            value={values?.ngayThuHoach}
            onChange={value => {
              setFieldValue(`ngayThuHoach`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
      </Grid>
    </div>
  );
};

export const FormPhanBon = ({
  values,
  errors,
  setFieldValue,
  loaiPhanBonList
}) => {
  const [alert, setAlert] = useState(false);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid
          container
          mt={"-5px"}
          className="capPhep-listInput-container-form"
        >
          <FieldArray
            name="phanBons"
            render={arrayHelpers => (
              <>
                {" "}
                {values?.phanBons?.length > 0 &&
                  values?.phanBons?.map((item, index) => {
                    return (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <div className="capPhep-listInput-title">
                            Lần bón phân {`thứ ${index + 1}`}{" "}
                            {index > 0 ? (
                              <div
                                className="capPhep-listInput-removeItem"
                                onClick={() => setAlert(index)}
                              >
                                {" "}
                                Xóa{" "}
                              </div>
                            ) : null}{" "}
                          </div>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelect
                            required
                            label="Loại phân bón:"
                            placeholder="Chọn..."
                            value={values?.phanBons?.[index]?.loaiPhanBon}
                            options={loaiPhanBonList || []}
                            name="loaiPhan"
                            onChange={(event, value) => {
                              setFieldValue(
                                `phanBons.[${index}].loaiPhanBon`,
                                value
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            label="Ngày bón phân:"
                            placeholder="Chọn..."
                            value={values?.phanBons?.[index]?.ngayDung}
                            onChange={value => {
                              setFieldValue(
                                `phanBons.[${index}].ngayDung`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`phanBons.[${index}].moTa`}>
                            {({ field }) => (
                              <MyTextFieldArea
                                label="Mô tả:"
                                placeholder="Nhập..."
                                maxRows={3}
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12}>
                          {values?.phanBons?.length > 0 && (
                            <div className="capPhep-listInput-underlineItem"></div>
                          )}
                        </Grid>
                      </Grid>
                    );
                  })}
                <Dialog
                  open={alert || alert === 0 ? true : false}
                  onClose={() => setAlert(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle className="capPhep-listInput-dialog-title">
                    {" "}
                    Bạn chắc chắn muốn xóa thông tin lần bón phân này?{" "}
                  </DialogTitle>
                  <DialogActions
                    className="capPhep-listInput-dialog-content"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MyButton
                      onClick={() => setAlert(false)}
                      txt="Không"
                      color="rgb(192, 44, 64)"
                      className="capPhep-listInput-dialog-buttonClose"
                      icon={<Close />}
                    />
                    <MyButton
                      onClick={() => {
                        arrayHelpers.remove(alert);
                        setAlert(false);
                      }}
                      txt="có"
                      className="capPhep-listInput-dialog-buttonCheck"
                      icon={<Check />}
                    />
                  </DialogActions>
                </Dialog>
                <div
                  className="capPhep-listInput-pushArray"
                  onClick={() =>
                    arrayHelpers.push({
                      loaiPhanBon: null
                    })
                  }
                >
                  <AddCircleOutline className="capPhep-listInput-pushArray-buttonAdd" />{" "}
                  <div>Thêm lần bón phân</div>
                </div>
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export const FormBenhHai = ({
  values,
  errors,
  setFieldValue,
  loaiBenhHaiList
}) => {
  const [alert, setAlert] = useState(false);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid
          container
          mt={"-5px"}
          className="capPhep-listInput-container-form"
        >
          <FieldArray
            name="benhHais"
            render={arrayHelpers => (
              <>
                {" "}
                {values?.benhHais?.length > 0 &&
                  values?.benhHais?.map((item, index) => {
                    return (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <div className="capPhep-listInput-title">
                            Lần bệnh hại {`thứ ${index + 1}`}{" "}
                            {index > 0 ? (
                              <div
                                className="capPhep-listInput-removeItem"
                                onClick={() => setAlert(index)}
                              >
                                {" "}
                                Xóa{" "}
                              </div>
                            ) : null}{" "}
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <MySelect
                            required
                            label="Loại bệnh hại:"
                            placeholder="Chọn..."
                            value={values?.benhHais?.[index]?.loaiBenhHai}
                            options={loaiBenhHaiList || []}
                            name="tenBenhHai"
                            onChange={(event, value) => {
                              setFieldValue(
                                `benhHais.[${index}].loaiBenhHai`,
                                value
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            label="Ngày phát bệnh:"
                            placeholder="Chọn..."
                            value={values?.benhHais?.[index]?.ngayPhatBenh}
                            onChange={value => {
                              setFieldValue(
                                `benhHais.[${index}].ngayPhatBenh`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            label="Ngày kết thúc:"
                            placeholder="Chọn..."
                            value={values?.benhHais?.[index]?.ngayKetThuc}
                            onChange={value => {
                              setFieldValue(
                                `benhHais.[${index}].ngayKetThuc`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`benhHais.[${index}].moTa`}>
                            {({ field }) => (
                              <MyTextFieldArea
                                label="Mô tả:"
                                placeholder="Nhập..."
                                maxRows={3}
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12}>
                          {values?.benhHais?.length > 0 && (
                            <div className="capPhep-listInput-underlineItem"></div>
                          )}
                        </Grid>
                      </Grid>
                    );
                  })}
                <Dialog
                  open={alert || alert === 0 ? true : false}
                  onClose={() => setAlert(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle className="capPhep-listInput-dialog-title">
                    {" "}
                    Bạn chắc chắn muốn xóa thông tin lần bón phân này?{" "}
                  </DialogTitle>
                  <DialogActions
                    className="capPhep-listInput-dialog-content"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MyButton
                      onClick={() => setAlert(false)}
                      txt="Không"
                      color="rgb(192, 44, 64)"
                      className="capPhep-listInput-dialog-buttonClose"
                      icon={<Close />}
                    />
                    <MyButton
                      onClick={() => {
                        arrayHelpers.remove(alert);
                        setAlert(false);
                      }}
                      txt="có"
                      className="capPhep-listInput-dialog-buttonCheck"
                      icon={<Check />}
                    />
                  </DialogActions>
                </Dialog>
                <div
                  className="capPhep-listInput-pushArray"
                  onClick={() =>
                    arrayHelpers.push({
                      loaiBenhHai: null
                    })
                  }
                >
                  <AddCircleOutline className="capPhep-listInput-pushArray-buttonAdd" />{" "}
                  <div>Thêm lần bệnh hại</div>
                </div>
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export const FormThuocTruSau = ({
  values,
  errors,
  setFieldValue,
  loaiThuocTruSauList
}) => {
  const [alert, setAlert] = useState(false);

  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid
          container
          mt={"-5px"}
          className="capPhep-listInput-container-form"
        >
          <FieldArray
            name="thuocTruSaus"
            render={arrayHelpers => (
              <>
                {" "}
                {values?.thuocTruSaus?.length > 0 &&
                  values?.thuocTruSaus?.map((item, index) => {
                    return (
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <div className="capPhep-listInput-title">
                            Lần dùng thuốc trừ sâu {`thứ ${index + 1}`}{" "}
                            {index > 0 ? (
                              <div
                                className="capPhep-listInput-removeItem"
                                onClick={() => setAlert(index)}
                              >
                                {" "}
                                Xóa{" "}
                              </div>
                            ) : null}{" "}
                          </div>
                        </Grid>
                        <Grid item xs={6}>
                          <MySelect
                            required
                            label="Loại thuốc trừ sâu:"
                            placeholder="Chọn..."
                            value={
                              values?.thuocTruSaus?.[index]?.loaiThuocTruSau
                            }
                            options={loaiThuocTruSauList || []}
                            name="tenThuoc"
                            onChange={(event, value) => {
                              setFieldValue(
                                `thuocTruSaus.[${index}].loaiThuocTruSau`,
                                value
                              );
                            }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <MySelectTime
                            label="Ngày dùng thuốc:"
                            placeholder="Chọn..."
                            value={values?.thuocTruSaus?.[index]?.ngayDung}
                            onChange={value => {
                              setFieldValue(
                                `thuocTruSaus.[${index}].ngayDung`,
                                value
                              );
                            }}
                            width="100%"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FastField name={`thuocTruSaus.[${index}].moTa`}>
                            {({ field }) => (
                              <MyTextFieldArea
                                label="Mô tả:"
                                placeholder="Nhập..."
                                maxRows={3}
                                {...field}
                              />
                            )}
                          </FastField>
                        </Grid>
                        <Grid item xs={12}>
                          {values?.thuocTruSaus?.length > 0 && (
                            <div className="capPhep-listInput-underlineItem"></div>
                          )}
                        </Grid>
                      </Grid>
                    );
                  })}
                <Dialog
                  open={alert || alert === 0 ? true : false}
                  onClose={() => setAlert(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle className="capPhep-listInput-dialog-title">
                    {" "}
                    Bạn chắc chắn muốn xóa thông tin lần dùng thuốc trừ sâu này?{" "}
                  </DialogTitle>
                  <DialogActions
                    className="capPhep-listInput-dialog-content"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <MyButton
                      onClick={() => setAlert(false)}
                      txt="Không"
                      color="rgb(192, 44, 64)"
                      className="capPhep-listInput-dialog-buttonClose"
                      icon={<Close />}
                    />
                    <MyButton
                      onClick={() => {
                        arrayHelpers.remove(alert);
                        setAlert(false);
                      }}
                      txt="có"
                      className="capPhep-listInput-dialog-buttonCheck"
                      icon={<Check />}
                    />
                  </DialogActions>
                </Dialog>
                <div
                  className="capPhep-listInput-pushArray"
                  onClick={() =>
                    arrayHelpers.push({
                      loaiThuocTruSau: null
                    })
                  }
                >
                  <AddCircleOutline className="capPhep-listInput-pushArray-buttonAdd" />{" "}
                  <div>Thêm lần dùng thuốc trừ sâu</div>
                </div>
              </>
            )}
          />
        </Grid>
      </Grid>
    </div>
  );
};
